import { render, staticRenderFns } from "./CommissionRates.vue?vue&type=template&id=728ecf62&"
import script from "./CommissionRates.vue?vue&type=script&lang=js&"
export * from "./CommissionRates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports